<template>
  <sl-content 
    pagetype="4" 
    pagename="slintelligentsystems"
    :title="$t('sl.si.title') "
    titlecolor="blue"
  />
</template>

<script>
import Vue from 'vue';
import SlContent from '@/views/Layout/SlContent';

  export default {
    name: 'intelligent-systems',
   
    components: {
      SlContent
    },
     data() {
      return {
      };
    },
  };
</script>

